<div class="uploadTitle"><b>Remember to include the Contract Information Sheet for this contract</b></div>
<div><b>Save In:</b> {{folder?.propertiesObj.PathName }}</div>
<button class="selectButton" mat-raised-button color="primary" (click)="fileSelector.click() ">Select File</button>

<input class="fileSelector" #fileSelector type="file" ng2FileSelect [uploader]="uploader" />
<ng-container *ngIf="file$ | async as file">
  <div *ngIf="file">
    <b>Filename: </b> {{file?.name}} <mat-error *ngIf="!file?.isPDF">File is not in PDF format - No Preview is available
    </mat-error><br>
    <b>File size: </b> {{ displaySize(file?.size)}} MB <mat-error *ngIf="displaySize(file?.size) > fileWarnSize">This is
      a big file and will take a long time to upload</mat-error> <br>
    <!-- <b>File hash: </b> {{file?.hash}} -->
    <br>
  </div>
  <pdf-viewer *ngIf="file?.isPDF" class="preview" #preview [original-size]="false" [src]="pdfData" [render-text]="true"
    fxFlexAlign="center" [show-all]="false">
  </pdf-viewer>
</ng-container>
